import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';

function EmotionButton(props) {
  const { emotion, display, onClick, selected } = props;

  return (
    <Button
      id={`btn-${emotion}`}
      data-emotion={emotion}
      className="btn-circle"
      selected={selected}
      onClick={onClick}
    >
      <span>{display}</span>
    </Button>
  );
}

EmotionButton.propTypes = {
  emotion: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
};

export default EmotionButton;



// WEBPACK FOOTER //
// ./app/components/EmotionButton.js